import HeroSection from '@/components/HeroSection';
import ClientsMarquee from '@/components/ClientsMarquee';
import PromoCards from '@/components/PromoCards';
import AboutSection from '@/components/AboutSection';
import WorkProcess from '@/components/WorkProcess';
import CTASection from '@/components/CTASection';

const HomePage = () => {
  return (
    <main>
      <HeroSection />
      <ClientsMarquee />
      <PromoCards />
      <AboutSection />
      <WorkProcess />
      <CTASection />
    </main>
  );
};

export default HomePage;
